export default "__VITE_ASSET__34e88b9f__"